<template>
  <div>
    Accès non autorisé à la page demandée.
  </div>
</template>

<script>
export default {
  name: 'NotAllowed'
};
</script>
